import { PrimaryButton, Stack, Text } from "@fluentui/react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSmartBack } from "../../utils/item-helper";

interface MessagePageProps {
  icon: string;
  iconAlt?: string;
  title: React.ReactNode;
  subtitle: React.ReactNode;
  buttons?: { text: string; onClick: () => void }[];
}

export default function MessagePage({
  icon,
  iconAlt = "icon",
  title,
  subtitle,
  buttons = [],
}: MessagePageProps) {
  const navigate = useNavigate();
  const goBack = useSmartBack("/");
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handleBack = () => {
      goBack();
    };
    window.addEventListener("popstate", handleBack);
    return () => window.removeEventListener("popstate", handleBack);
  }, [navigate]);
  return (
    <div className="login-background">
      <div className="login-card">
        <div className="login-icon">
          <img src={icon} alt={iconAlt} className="login-img" />
        </div>
        <h2 className="login-title">{title}</h2>
        <Text className="login-subtitle">{subtitle}</Text>
        {buttons.length > 0 && (
          <Stack
            horizontal
            tokens={{ childrenGap: 20 }}
            horizontalAlign="center"
            style={{ marginTop: "20px" }}>
            {buttons.map((btn, idx) => (
              <PrimaryButton
                key={idx}
                text={btn.text}
                className="login-button"
                onClick={btn.onClick} />
            ))}
          </Stack>
        )}
      </div>
    </div>
  );
}